<template>
  <div class="add-container">
    <div class="country">
      <country-item @click="handleCountryItem" :countrys="countrys" :active="country.code" />
    </div>

    <div v-loading.lock="loading" class="country-form-field">
      <country-form-field v-if="formSource.languageId" :formSource="formSource" :kakaUrl="kakaUrl" :firstCategory="firstCategory" />
      <el-empty v-else class="el-empty" :description="loading ? '加载中...' : '暂无数据'" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import API from '@/api'
import CountryItem from './CountryItem.vue'
import CountryFormField from './CountryFormField.vue'

// // 接口请求参数格式
// let parameter = {
//   languageId: "1", // 语言id
//   spuCode: "AMN01387", // spu
//   productName: "TEST", // 商品名称
//   virtualWarehouseId: undefined, // 虚拟仓库
//   lockIng: undefined, // 通用信息 - 是否隐藏
//   sizeImagePath: "spu_size/AMN01387.jpg", // 尺码图片
//   imgUrl: [
//     "https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/image%2FAMN01387%2FAMN01387_B_S_AU%2Fa914efbee4e9ce361983f53b82b24dee.jpg"
//   ], // spu图片集合
//   description: "test", // 描述
//   categoryId: "", // 品类id
//   policyId: "", // 条款id
//   variableList: [{
//     id: 1,
//     languageId: "1", // 语言id
//     skuCode: "AMN01387_GR_S_AU", // sku编码
//     option1: "{\"name\":\"color\",\"value\":\"grey\"}", // 变体1（对应列表Color字段）
//     option2: "{\"name\":\"size\",\"value\":\"pattern\"}", // 变体2（对应列表Size字段）
//     material: "test", // 材质
//     packageWeight: 6, // 重量g
//     packageLength: 6, // 长cm
//     packageWidth: 6, // 宽cm
//     packageHeight: 6, // 高cm
//     cost: 41.04, // 成本
//     price: null, // 售价
//     imagesList: [{
//       imgUrl: "https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/image%2FAMN01387%2FAMN01387_GR_XL_AU%2Fe3cb41f8b63543dd86c80f8cfe8360d7.jpg",
//       status: 1
//     }], // 图片
//     profitRate: "", // 利润率
//     minOrderQuantity: "", // 最小起定量
//     earnestMoneyRate: "", // 订金比例
//     skuName: "" // sku名称
//   }] // 变体信息
// }

export default {
  components: {
    'country-item': CountryItem,
    'country-form-field': CountryFormField
  },
  data() {
    return {
      loading: false,
      countrys: [], // 左侧语言列表数据
      country: {}, // 当前选中的国家
      formSource: {}, // 当前点击的国家的表单数据源
      countryFormFieldSource: {}, // 唯一数据源
      mode: 'add',
      kakaUrl: process.env.VUE_APP_KAKACLO_URL+'/product-detail',
      firstCategory: ''
    }
  },
  created() {
    this.getPublicSelectData()
    this.mode = this.$route.path.slice(-5) === 'goods' ? 'add' : 'edit'
  },
  methods: {
    // 获取语言列表
    async getPublicSelectData() {
      try {
        let { data } = await API.getPublicSelectData({ type: 1, param: undefined })
        this.countrys = data
        this.structureDataSource()
        if (this.$route.query.id) {
          this.editProduct(this.countrys[0].code)
        } else {
          this.countrys.length && (this.formSource = this.countryFormFieldSource[this.countrys[0].code])
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },

    // 根据语言ID和商品ID获取详情
    async editProduct(languageId) {
      try {
        this.loading = true
        let { data } = await API.editProduct({ kkProductId: this.$route.query.id, languageId })
        if (data) {
          data.variableList &&
            data.variableList.forEach((item) => {
              if (item.option1 || item.option2 || item.option3) {
                item.option1 = item.option1 ? JSON.parse(item.option1) : undefined
                item.option2 = item.option2 ? JSON.parse(item.option2) : undefined
                item.option3 = item.option3 ? JSON.parse(item.option3) : undefined
              }
            })
          this.countrys.length && (this.formSource = Object.assign(this.countryFormFieldSource[languageId], data))
          this.setSeoUrl(data.seoSearchTerm)
        } else {
          if (this.countrys.length) {
            this.formSource = this.countryFormFieldSource[languageId]
            this.formSource.kkProductId = this.$route.query.id
          }
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        throw new Error(error.message)
      }
    },

    setSeoUrl(url) {
      if (url) {
        let diagonalidx = url.slice(1, url.length).indexOf('/')
        let firstCategory = url.slice(1, diagonalidx + 1)
        this.kakaUrl += `/${firstCategory}/`
        this.firstCategory = `/${firstCategory}/`
      }
    },

    // 构造唯一数据源
    structureDataSource() {
      let countryFormFieldSource = {}
      for (let i = 0; i < this.countrys.length; i++) {
        countryFormFieldSource[this.countrys[i].code] = {
          languageId: this.countrys[i].code, // 语言id
          spuCode: undefined, // 通用信息 - spu
          productName: undefined, // 通用信息 - 商品名称
          virtualWarehouseId: undefined, // 通用信息 - 虚拟仓库
          lockIng: undefined, // 通用信息 - 是否隐藏
          categoryId: undefined, // 通用信息 - 品类
          description: undefined, // 通用信息 - 描述
          policyId: undefined, // 通用信息 - 退换条款
          sizeImagePath: undefined, // 通用信息 - 尺码表
          imgUrl: [], // 通用信息 - 图片
          variableList: [
            // {
            //   skuCode: 'sku', // SKU
            //   option1: 'color', // Color
            //   option2: 'size', // Size
            //   material: '上衣:20% 棉,80% 涤纶;裤子:10% 棉,90% 羊毛;100% 棉', // 材质示例：'上衣:20% 棉,80% 涤纶;裤子:10% 棉,90% 羊毛;100% 棉'
            //   imagesList: [{
            //     imgUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            //     status: true
            //   }, {
            //     imgUrl: 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
            //     status: false
            //   }], // 图片
            //   packageLength: undefined, // 包装尺寸 - 长
            //   packageWidth: undefined, // 包装尺寸 - 宽
            //   packageHeight: undefined, // 包装尺寸 - 高
            //   packageWeight: undefined, // 重量
            //   cost: 3.28, // 成本
            //   price: undefined, // 售价
            //   profitRate: undefined, // 利润率
            //   minOrderQuantity: undefined, // 起订量
            //   proportion: undefined, // 订金比例
            //   status: 0, // 上架状态：1.上架 0.下架
            // }
          ] // 变体信息
        }
      }
      this.countryFormFieldSource = _.cloneDeep(countryFormFieldSource)
    },

    // 左侧 - 点击每个国家触发的事件
    handleCountryItem(country) {
      if (country.code === this.country.code) return
      this.country = country
      if (this.$route.params.id) {
        this.editProduct(country.code)
      } else {
        this.formSource = this.countryFormFieldSource[country.code]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-container {
  height: 100%;
  .country {
    float: left;
    width: 98px;
    height: 100%;
    min-width: 98px;
    margin-right: 5px;
    background-color: #fff;
  }

  .country-form-field {
    position: relative;
    float: right;
    height: 100%;
    width: calc(100% - 98px - 5px);
    .el-empty {
      position: absolute;
      top: 50%;
      left: 50%;
      padding: 0;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
